import { clienteApi } from '../../common/axios';

export const ordiniService = {
  list: () => clienteApi.get('/cliente/ordini'),
  get: (id) => clienteApi.get(`/cliente/ordini/${id}`),
  create: (data) => clienteApi.post('/cliente/ordini', data),
  ricevuto: (id) => clienteApi.post(`/cliente/ordini/${id}/ricevuto`),
  richiediRimborso: (id, motivo) => clienteApi.post(`/cliente/ordini/${id}/richiedi-rimborso`, { motivo }),
  preventivo: (data) => clienteApi.post('/catalogo/preventivo', data),
  pdfOrdine: (id) => `/cliente/ricevute/ordini/${id}/pdf`,
  pdfPagamento: (id) => `/cliente/ricevute/pagamenti/${id}/pdf`,
};

export const profileService = {
  update: (data) => clienteApi.put('/cliente/profile', data),
};

export const accountService = {
  statoCancellazione: () => clienteApi.get('/cliente/account/cancellazione'),
  richiediCancellazione: (data) => clienteApi.post('/cliente/account/cancellazione', data),
  annullaCancellazione: () => clienteApi.delete('/cliente/account/cancellazione'),
};

export const segnalazioniService = {
  list: () => clienteApi.get('/cliente/segnalazioni'),
  create: (data) => clienteApi.post('/cliente/segnalazioni', data),
};

export default ordiniService;
